export const HeaderChatBellTestIds = {
  BELL: 'header-chat.bell-button',
};
